var map = {
	"./Ada IDE.dark.png": 8661,
	"./Ada IDE.darkplus.png": 3478,
	"./Ada IDE.default.png": 6146,
	"./Ada IDE.onedark.png": 5453,
	"./Ada IDE.pink.png": 317,
	"./Ada IDE.real-dark.png": 8888,
	"./Android Java IDE.dark.png": 4952,
	"./Android Java IDE.darkplus.png": 8824,
	"./Android Java IDE.default.png": 7629,
	"./Android Java IDE.onedark.png": 1650,
	"./Android Java IDE.pink.png": 4784,
	"./Android Java IDE.real-dark.png": 8275,
	"./Android Kotlin IDE.dark.png": 5925,
	"./Android Kotlin IDE.darkplus.png": 6041,
	"./Android Kotlin IDE.default.png": 4802,
	"./Android Kotlin IDE.onedark.png": 8781,
	"./Android Kotlin IDE.pink.png": 8301,
	"./Android Kotlin IDE.real-dark.png": 3432,
	"./C++ Cmake.dark.png": 4089,
	"./C++ Cmake.darkplus.png": 541,
	"./C++ Cmake.default.png": 7334,
	"./C++ Cmake.onedark.png": 3009,
	"./C++ Cmake.pink.png": 6033,
	"./C++ Cmake.real-dark.png": 6620,
	"./Diff of Two Compilers.dark.png": 8637,
	"./Diff of Two Compilers.darkplus.png": 8913,
	"./Diff of Two Compilers.default.png": 106,
	"./Diff of Two Compilers.onedark.png": 1701,
	"./Diff of Two Compilers.pink.png": 4981,
	"./Diff of Two Compilers.real-dark.png": 464,
	"./Diff of Two Sources.dark.png": 6433,
	"./Diff of Two Sources.darkplus.png": 693,
	"./Diff of Two Sources.default.png": 7710,
	"./Diff of Two Sources.onedark.png": 6425,
	"./Diff of Two Sources.pink.png": 361,
	"./Diff of Two Sources.real-dark.png": 2004,
	"./Java IDE.dark.png": 8233,
	"./Java IDE.darkplus.png": 6301,
	"./Java IDE.default.png": 7014,
	"./Java IDE.onedark.png": 2689,
	"./Java IDE.pink.png": 2558,
	"./Java IDE.real-dark.png": 1420,
	"./LLVM IR.dark.png": 1297,
	"./LLVM IR.darkplus.png": 3045,
	"./LLVM IR.default.png": 2817,
	"./LLVM IR.onedark.png": 6137,
	"./LLVM IR.pink.png": 8377,
	"./LLVM IR.real-dark.png": 3732,
	"./Pascal IDE.dark.png": 9869,
	"./Pascal IDE.darkplus.png": 7649,
	"./Pascal IDE.default.png": 5594,
	"./Pascal IDE.onedark.png": 613,
	"./Pascal IDE.pink.png": 2709,
	"./Pascal IDE.real-dark.png": 8576,
	"./Preprocessor.dark.png": 6502,
	"./Preprocessor.darkplus.png": 7626,
	"./Preprocessor.default.png": 2595,
	"./Preprocessor.onedark.png": 7988,
	"./Preprocessor.pink.png": 7158,
	"./Preprocessor.real-dark.png": 9953
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4906;